export const docTypes = [
    'Документы',
    'Родителям',
    'Специалистам',
    'Личные'
]